var PermissionVm = (function () {
    function PermissionVm() {
    }
    PermissionVm.prototype.isMCDisabled = function () {
        return false;
    };
    return PermissionVm;
}());
export { PermissionVm };
